export default {
  crop_cycle: [
    "Aceituna",
    "Acelga",
    "Achiote",
    "Agave",
    "Aguacate",
    "Ajo",
    "Ajonjolí",
    "Albahaca",
    "Alcachofa",
    "Alcatraz (gruesa)",
    "Alfalfa achicalada",
    "Alfalfa verde",
    "Algodón",
    "Almendro",
    "Alpiste",
    "Amaranto",
    "Anís",
    "Apio",
    "Arándano",
    "Arrayán",
    "Arroz",
    "Avena forrajera en verde",
    "Avena grano",
    "Bambú",
    "Berenjena",
    "Betabel",
    "Brocoli",
    "Cacahuate",
    "Cacao",
    "Café cereza",
    "Calabaza",
    "Camote",
    "Caña de azúcar",
    "Canola",
    "Carambolo",
    "Cebada",
    "Cebada forrajera en verde",
    "Cebolla",
    "Cereza",
    "Chabacano",
    "Chícharo",
    "Chayote",
    "Chía",
    "Chilacayote",
    "Chile / Pimiento",
    "Chirimoya",
    "Cilantro",
    "Ciruela",
    "Coco fruta",
    "Col (repollo)",
    "Col de Bruselas",
    "Coliflor",
    "Comino",
    "Crisantemo (planta)",
    "Durazno",
    "Dátil",
    "Ejote",
    "Elote",
    "Eneldo",
    "Epazote",
    "Espárrago",
    "Especias y medicinales",
    "Espinaca",
    "Frambuesa",
    "Fresa",
    "Frijol",
    "Garbanzo",
    "Girasol",
    "Granada",
    "Guanábana",
    "Guayaba",
    "Henequén",
    "Hierbabuena",
    "Hierbas aromáticas",
    "Higo",
    "Jamaica",
    "Jenjibre",
    "Jícama",
    "Lechuga",
    "Lenteja",
    "Lima",
    "Limón",
    "Linaza",
    "Litchi",
    "Maíz",
    "Macadamia",
    "Maguey",
    "Mamey",
    "Mandarina",
    "Mango",
    "Mangostán",
    "Manzanilla",
    "Manzano",
    "Maracuyá",
    "Margarita",
    "Mejorana",
    "Melón",
    "Membrillo",
    "Menta",
    "Moringa",
    "Nabo",
    "Nanche",
    "Napa",
    "Naranja",
    "Níspero",
    "Nochebuena (planta)",
    "Nogal",
    "Noni",
    "Nopal",
    "Orégano",
    "Ornamentales",
    "Orquídea (planta)",
    "Palma africana o de aceite",
    "Papa",
    "Papaya",
    "Pastizales",
    "Pasto tapete (m2)",
    "Pastos y praderas",
    "Pepino",
    "Peral",
    "Perejil",
    "Perón",
    "Persimonio",
    "Pimienta",
    "Piña",
    "Piñón",
    "Pistache",
    "Pitaya",
    "Plátano",
    "Poro",
    "Rábano",
    "Rambután",
    "Romerito",
    "Romero",
    "Sábila",
    "Sandía",
    "Sorgo",
    "Soya",
    "Stevia",
    "Tabaco",
    "Tamarindo",
    "Tejocote",
    "Tomate Rojo (jitomate)",
    "Tomate Verde",
    "Tomillo",
    "Toronja (pomelo)",
    "Trébol",
    "Trigo",
    "Tulipán holandés",
    "Tuna",
    "Uva",
    "Vainilla",
    "Verdolaga",
    "Vid",
    "Yuca alimenticia",
    "Zanahoria",
    "Zapote",
    "Zarzamora",
    "Zempoalxochitl",
    "barbecho",
    "Otro",
  ],
  crop_cycle_en: [
    "olive",
    "chard",
    "achiote",
    "agave",
    "avocado",
    "garlic",
    "sesame",
    "basil",
    "artichoke",
    "alcatraz",
    "shrunkenAlfalfa",
    "greenAlfalfa",
    "cotton",
    "almond",
    "birdseed",
    "amaranth",
    "anise",
    "celery",
    "blueberry",
    "myrtle",
    "rice",
    "greenForageOats",
    "oatGrain",
    "bamboo",
    "eggplant",
    "beetroot",
    "broccoli",
    "peanut",
    "cocoa",
    "cherryCoffee",
    "pumpkin",
    "sweetPotato",
    "sugarCane",
    "canola",
    "carambolo",
    "barley",
    "greenForageBarley",
    "onion",
    "cherry",
    "chabacano",
    "pea",
    "squash",
    "chia",
    "chilacayote",
    "chillyPepper",
    "custardApple",
    "coriander",
    "plum",
    "coconutFruit",
    "cabbage",
    "brusselsSprouts",
    "cauliflower",
    "cumin",
    "chrysanthemum",
    "peach",
    "Date",
    "greenBean",
    "cornCob",
    "dill",
    "epazote",
    "asparagus",
    "spicesAndMedicinals",
    "spinach",
    "raspberry",
    "strawberry",
    "bean",
    "chickpea",
    "sunflower",
    "pomegranate",
    "soursop",
    "guava",
    "Henequen",
    "Peppermint",
    "Aromatic herbs",
    "fig",
    "jamaica",
    "ginger",
    "jicama",
    "lettuce",
    "lentil",
    "lime",
    "lemon",
    "linseed",
    "litchi",
    "corn",
    "macadamia",
    "maguey",
    "mamey",
    "tangerine",
    "mango",
    "mangosteen",
    "chamomile",
    "appleTree",
    "passionFruit",
    "daisyFlower",
    "marjoram",
    "melon",
    "quince",
    "mint",
    "moringa",
    "turnip",
    "nanche",
    "napa",
    "orange",
    "medlar",
    "nochebuena",
    "walnut",
    "noni",
    "nopal",
    "oregano",
    "ornamental",
    "orchid",
    "oilPalm",
    "potato",
    "papaya",
    "grasslands",
    "matGrass",
    "pasturesAndMeadows",
    "cucumber",
    "pearTree",
    "parsley",
    "peron",
    "persimony",
    "pepper",
    "pineapple",
    "pinion",
    "pistache",
    "pitaya",
    "banana",
    "pore",
    "radish",
    "rambutan",
    "romerito",
    "rosemary",
    "aloe",
    "watermelon",
    "sorghum",
    "soy",
    "stevia",
    "tobacco",
    "tamarind",
    "tejocote",
    "tomato",
    "greenTomato",
    "thyme",
    "grapefruit",
    "clover",
    "wheat",
    "dutchTulip",
    "tuna",
    "grape",
    "vanilla",
    "purslane",
    "vine",
    "cassavaFood",
    "carrot",
    "sapodilla",
    "blackberry",
    "zempoalxochitl",
    "fallow",
    "other",
  ],
  lastCropCycle: {},
  isIssueArea: false,
  issueArea: [],
};
